module.exports = __webpack_public_path__ + "static/image1_en-f2d414e9c06292be484ff3270113b06f.png";